import { Route, Routes } from '@angular/router';
import { AuthenticatedGuard } from '@lib/shared/guards/authenticated.guard';
import { ExpiredLicenceGuard } from '@lib/shared/guards/expiredLicence.guard';

import { ShellComponent } from './pe-pro-shell.component';

/**
 * Provides helper methods to create routes.
 */

export class Shell {
  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */

  static childRoutes(routes: Routes): Route {
    return {
      path: 'tabs',
      component: ShellComponent,
      children: routes,
      canActivate: [AuthenticatedGuard, ExpiredLicenceGuard],
      // Reuse ShellComponent instance when navigating between child views
      data: { reuse: true },
      // data: { reuse: true },
    };
  }
}
